import {
  listenFormCheck,
  listenNumberButtons,
  listenRemoveButtons,
  listenPreOrder,
  listenPreOrderButton,
  listenRemoveSelectedProducts,
  listenSelectedProducts,
  listenBuyOneClick,
  listenBuyEventAndUpdateCartList,
  listenFormWithCart,
  listenNumberInputs, fixOneClickMainProductRemove,
} from '../../../../service/listner/cart';
import { validateNumberInput } from '../../../../service/validate';

export function ICartButtons() {
  initCartListListeners();
  listenBuyEventAndUpdateCartList();

  listenPreOrder();
  listenBuyOneClick();
  listenPreOrderButton();
  listenFormWithCart();

  listenSmCartReInit();
  fixOneClickMainProductRemove();
}

function initCartListListeners() {
  listenSelectedProducts();
  listenFormCheck();
  listenNumberButtons();
  listenNumberInputs();
  listenRemoveButtons();
  validateNumberInput();
  listenRemoveSelectedProducts();
}

function listenSmCartReInit() {
  const smCart = document.querySelector('.header-account-link');
  smCart.addEventListener('SmCart:init', () => {
    initCartListListeners();
  });
}
